<template>
  <div>
    <c-card>
      <c-card-header>
        <strong>Standard buttons</strong>
        <div class="card-header-actions">
          <a
            href="https://coreui.io/vue/docs/components/button-components"
            class="card-header-action"
            rel="noreferrer noopener"
            target="_blank"
          >
            <small class="text-muted">docs</small>
          </a>
        </div>
      </c-card-header>
      <c-card-body>
        <c-row class="align-items-center">
          <c-col col="12" xl class="mb-3 mb-xl-0">
            Normal
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="primary">Primary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="secondary">Secondary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="success">Success</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="warning">Warning</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="danger">Danger</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="info">Info</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="light">Light</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="dark">Dark</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="link">Link</c-button>
          </c-col>
        </c-row>
        <c-row class="align-items-center mt-3">
          <c-col col="12" xl class="mb-3 mb-xl-0">
            Active State
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button pressed block color="primary" aria-pressed="true">Primary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button pressed block color="secondary" aria-pressed="true">Secondary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button pressed block color="success" aria-pressed="true">Success</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button pressed block color="warning" aria-pressed="true">Warning</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button pressed block color="danger" aria-pressed="true">Danger</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button pressed block color="info" aria-pressed="true">Info</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button pressed block color="light" aria-pressed="true">Light</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button pressed block color="dark" aria-pressed="true">Dark</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button pressed block color="link" aria-pressed="true">Link</c-button>
          </c-col>
        </c-row>
        <c-row class="align-items-center mt-3">
          <c-col col="12" xl class="mb-3 mb-xl-0">
            Disabled
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="primary" disabled>Primary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="secondary" disabled>Secondary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="success" disabled>Success</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="warning" disabled>Warning</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="danger" disabled>Danger</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="info" disabled>Info</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="light" disabled>Light</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="dark" disabled>Dark</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="link" disabled>Link</c-button>
          </c-col>
        </c-row>
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <strong>Outline Buttons</strong>
      </c-card-header>
      <c-card-body>
        <p>
          Use
          <code>variant="outline"</code>
          prop
        </p>
        <c-row class="align-items-center">
          <c-col col="12" xl class="mb-3 mb-xl-0">
            Normal
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="outline" color="primary">Primary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="outline" color="secondary">Secondary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="outline" color="success">Success</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="outline" color="warning">Warning</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="outline" color="danger">Danger</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="outline" color="info">Info</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="outline" color="light">Light</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="outline" color="dark">Dark</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0"></c-col>
        </c-row>
        <c-row class="align-items-center mt-3">
          <c-col col="12" xl class="mb-3 mb-xl-0">
            Active State
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block pressed variant="outline" color="primary" aria-pressed="true">Primary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block pressed variant="outline" color="secondary" aria-pressed="true">Secondary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block pressed variant="outline" color="success" aria-pressed="true">Success</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block pressed variant="outline" color="warning" aria-pressed="true">Warning</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block pressed variant="outline" color="danger" aria-pressed="true">Danger</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block pressed variant="outline" color="info" aria-pressed="true">Info</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block pressed variant="outline" color="light" aria-pressed="true">Light</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block pressed variant="outline" color="dark" aria-pressed="true">Dark</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0"></c-col>
        </c-row>
        <c-row class="align-items-center mt-3">
          <c-col col="12" xl class="mb-3 mb-xl-0">
            Disabled
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="outline" color="primary" disabled>Primary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="outline" color="secondary" disabled>Secondary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="outline" color="success" disabled>Success</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="outline" color="warning" disabled>Warning</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="outline" color="danger" disabled>Danger</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="outline" color="info" disabled>Info</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="outline" color="light" disabled>Light</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="outline" color="dark" disabled>Dark</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0"></c-col>
        </c-row>
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <strong>Ghost Buttons</strong>
      </c-card-header>
      <c-card-body>
        <p>
          Use
          <code>variant="ghost"</code>
          prop for ghost buttons.
        </p>
        <c-row class="align-items-center">
          <c-col col="12" xl class="mb-3 mb-xl-0">
            Normal
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="ghost" color="primary">Primary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="ghost" color="secondary">Secondary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="ghost" color="success">Success</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="ghost" color="warning">Warning</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="ghost" color="danger">Danger</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="ghost" color="info">Info</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="ghost" color="light">Light</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="ghost" color="dark">Dark</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0"></c-col>
        </c-row>
        <c-row class="align-items-center mt-3">
          <c-col col="12" xl class="mb-3 mb-xl-0">
            Active State
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block pressed variant="ghost" color="primary" aria-pressed="true">Primary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block pressed variant="ghost" color="secondary" aria-pressed="true">Secondary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block pressed variant="ghost" color="success" aria-pressed="true">Success</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block pressed variant="ghost" color="warning" aria-pressed="true">Warning</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block pressed variant="ghost" color="danger" aria-pressed="true">Danger</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block pressed variant="ghost" color="info" aria-pressed="true">Info</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block pressed variant="ghost" color="light" aria-pressed="true">Light</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block pressed variant="ghost" color="dark" aria-pressed="true">Dark</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0"></c-col>
        </c-row>
        <c-row class="align-items-center mt-3">
          <c-col col="12" xl class="mb-3 mb-xl-0">
            Disabled
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="ghost" color="primary" disabled>Primary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="ghost" color="secondary" disabled>Secondary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="ghost" color="success" disabled>Success</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="ghost" color="warning" disabled>Warning</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="ghost" color="danger" disabled>Danger</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="ghost" color="info" disabled>Info</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="ghost" color="light" disabled>Light</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block variant="ghost" color="dark" disabled>Dark</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0"></c-col>
        </c-row>
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <strong>Square Buttons</strong>
      </c-card-header>
      <c-card-body>
        <p>
          Use
          <code>square</code>
          prop for square buttons.
        </p>
        <c-row class="align-items-center">
          <c-col col="12" xl class="mb-3 mb-xl-0">
            Normal
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="primary" square>Primary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="secondary" square>Secondary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="success" square>Success</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="warning" square>Warning</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="danger" square>Danger</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="info" square>Info</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="light" square>Light</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="dark" square>Dark</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="link" square>Link</c-button>
          </c-col>
        </c-row>
        <c-row class="align-items-center mt-3">
          <c-col col="12" xl class="mb-3 mb-xl-0">
            Active State
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button pressed block color="primary" square aria-pressed="true">Primary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button pressed block color="secondary" square aria-pressed="true">Secondary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button pressed block color="success" square aria-pressed="true">Success</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button pressed block color="warning" square aria-pressed="true">Warning</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button pressed block color="danger" square aria-pressed="true">Danger</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button pressed block color="info" square aria-pressed="true">Info</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button pressed block color="light" square aria-pressed="true">Light</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button pressed block color="dark" square aria-pressed="true">Dark</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button pressed block color="link" square aria-pressed="true">Link</c-button>
          </c-col>
        </c-row>
        <c-row class="align-items-center mt-3">
          <c-col col="12" xl class="mb-3 mb-xl-0">
            Disabled
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="primary" square disabled>Primary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="secondary" square disabled>Secondary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="success" square disabled>Success</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="warning" square disabled>Warning</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="danger" square disabled>Danger</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="info" square disabled>Info</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="light" square disabled>Light</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="dark" square disabled>Dark</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="link" square disabled>Link</c-button>
          </c-col>
        </c-row>
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <strong>Pill Buttons</strong>
      </c-card-header>
      <c-card-body>
        <p>
          Use
          <code>pill</code>
          prop for pill buttons.
        </p>
        <c-row class="align-items-center">
          <c-col col="12" xl class="mb-3 mb-xl-0">
            Normal
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="primary" shape="pill">Primary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="secondary" shape="pill">Secondary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="success" shape="pill">Success</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="warning" shape="pill">Warning</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="danger" shape="pill">Danger</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="info" shape="pill">Info</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="light" shape="pill">Light</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="dark" shape="pill">Dark</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="link" shape="pill">Link</c-button>
          </c-col>
        </c-row>
        <c-row class="align-items-center mt-3">
          <c-col col="12" xl class="mb-3 mb-xl-0">
            Active State
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button pressed block color="primary" shape="pill" aria-pressed="true">Primary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button pressed block color="secondary" shape="pill" aria-pressed="true">Secondary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button pressed block color="success" shape="pill" aria-pressed="true">Success</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button pressed block color="warning" shape="pill" aria-pressed="true">Warning</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button pressed block color="danger" shape="pill" aria-pressed="true">Danger</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button pressed block color="info" shape="pill" aria-pressed="true">Info</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button pressed block color="light" shape="pill" aria-pressed="true">Light</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button pressed block color="dark" shape="pill" aria-pressed="true">Dark</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button pressed block color="link" shape="pill" aria-pressed="true">Link</c-button>
          </c-col>
        </c-row>
        <c-row class="align-items-center mt-3">
          <c-col col="12" xl class="mb-3 mb-xl-0">
            Disabled
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="primary" shape="pill" disabled>Primary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="secondary" shape="pill" disabled>Secondary</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="success" shape="pill" disabled>Success</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="warning" shape="pill" disabled>Warning</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="danger" shape="pill" disabled>Danger</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="info" shape="pill" disabled>Info</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="light" shape="pill" disabled>Light</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="dark" shape="pill" disabled>Dark</c-button>
          </c-col>
          <c-col col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <c-button block color="link" shape="pill" disabled>Link</c-button>
          </c-col>
        </c-row>
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <strong>Sizes</strong>
      </c-card-header>
      <c-card-body>
        <p>
          Fancy larger or smaller buttons? Add
          <code>size="lg"</code>
          or
          <code>size="sm"</code>
          for additional sizes.
        </p>
        <c-row class="align-items-center">
          <c-col col="2" xl class="mb-3 mb-xl-0">
            Small
          </c-col>
          <c-col col="2" class="mb-3 mb-xl-0 text-center">
            <c-button color="primary" size="sm">Standard Button</c-button>
          </c-col>
          <c-col col="2" class="mb-3 mb-xl-0 text-center">
            <c-button variant="outline" color="secondary" size="sm">Outline Button</c-button>
          </c-col>
          <c-col col="2" class="mb-3 mb-xl-0 text-center">
            <c-button size="sm" variant="ghost" color="success">Ghost Button</c-button>
          </c-col>
          <c-col col="2" class="mb-3 mb-xl-0 text-center">
            <c-button color="warning" size="sm" square>Square Button</c-button>
          </c-col>
          <c-col col="2" class="mb-3 mb-xl-0 text-center">
            <c-button color="danger" size="sm" shape="pill">Pill Button</c-button>
          </c-col>
        </c-row>
        <c-row class="align-items-center mt-3">
          <c-col col="2" xl class="mb-3 mb-xl-0">
            Normal
          </c-col>
          <c-col col="2" class="mb-3 mb-xl-0 text-center">
            <c-button color="primary">Standard Button</c-button>
          </c-col>
          <c-col col="2" class="mb-3 mb-xl-0 text-center">
            <c-button variant="outline" color="secondary">Outline Button</c-button>
          </c-col>
          <c-col col="2" class="mb-3 mb-xl-0 text-center">
            <c-button variant="ghost" color="success">Ghost Button</c-button>
          </c-col>
          <c-col col="2" class="mb-3 mb-xl-0 text-center">
            <c-button color="warning" square>Square Button</c-button>
          </c-col>
          <c-col col="2" class="mb-3 mb-xl-0 text-center">
            <c-button color="danger" shape="pill">Pill Button</c-button>
          </c-col>
        </c-row>
        <c-row class="align-items-center mt-3">
          <c-col col="2" xl class="mb-3 mb-xl-0">
            Large
          </c-col>
          <c-col col="2" class="mb-3 mb-xl-0 text-center">
            <c-button color="primary" size="lg">Standard Button</c-button>
          </c-col>
          <c-col col="2" class="mb-3 mb-xl-0 text-center">
            <c-button variant="outline" color="secondary" size="lg">Outline Button</c-button>
          </c-col>
          <c-col col="2" class="mb-3 mb-xl-0 text-center">
            <c-button variant="ghost" color="success" size="lg">Ghost Button</c-button>
          </c-col>
          <c-col col="2" class="mb-3 mb-xl-0 text-center">
            <c-button color="warning" size="lg" square>Square Button</c-button>
          </c-col>
          <c-col col="2" class="mb-3 mb-xl-0 text-center">
            <c-button color="danger" size="lg" shape="pill">Pill Button</c-button>
          </c-col>
        </c-row>
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <strong>With Icons</strong>
      </c-card-header>
      <c-card-body>
        <c-row class="align-items-center">
          <c-col sm xs="12" class="text-center mt-3">
            <c-button color="primary">
              <c-icon name="cil-lightbulb" />
              &nbsp;Standard Button
            </c-button>
          </c-col>
          <c-col sm xs="12" class="text-center mt-3">
            <c-button color="secondary" variant="outline">
              <c-icon name="cil-lightbulb" />
              &nbsp;Outline Button
            </c-button>
          </c-col>
          <c-col sm xs="12" class="text-center mt-3">
            <c-button color="success">
              <c-icon name="cil-lightbulb" />
              &nbsp;Ghost Button
            </c-button>
          </c-col>
          <c-col sm xs="12" class="text-center mt-3">
            <c-button color="warning" square>
              <c-icon name="cil-lightbulb" />
              &nbsp;Square Button
            </c-button>
          </c-col>
          <c-col sm xs="12" class="text-center mt-3">
            <c-button color="danger" shape="pill">
              <c-icon name="cil-lightbulb" />
              &nbsp;Pill Button
            </c-button>
          </c-col>
        </c-row>
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <strong>Toggle pressed state</strong>
      </c-card-header>
      <c-card-body>
        <c-row>
          <c-col sm xs="12" class="text-center mt-3">
            <c-button variant="outline" color="primary" :pressed.sync="togglePress">
              Primary {{ togglePress ? 'On ' : 'Off' }}
            </c-button>
          </c-col>
          <c-col sm xs="12" class="text-center mt-3">
            <c-button variant="outline" color="secondary" :pressed.sync="togglePress">
              Secondary {{ togglePress ? 'On ' : 'Off' }}
            </c-button>
          </c-col>
          <c-col sm xs="12" class="text-center mt-3">
            <c-button variant="outline" color="success" :pressed.sync="togglePress">
              Success {{ togglePress ? 'On ' : 'Off' }}
            </c-button>
          </c-col>
          <c-col sm xs="12" class="text-center mt-3">
            <c-button variant="outline" color="info" :pressed.sync="togglePress">
              Info {{ togglePress ? 'On ' : 'Off' }}
            </c-button>
          </c-col>
          <c-col sm xs="12" class="text-center mt-3">
            <c-button variant="outline" color="warning" :pressed.sync="togglePress">
              Warning {{ togglePress ? 'On ' : 'Off' }}
            </c-button>
          </c-col>
          <c-col sm xs="12" class="text-center mt-3">
            <c-button variant="outline" color="danger" :pressed.sync="togglePress">
              Danger {{ togglePress ? 'On ' : 'Off' }}
            </c-button>
          </c-col>
        </c-row>
      </c-card-body>
    </c-card>
    <c-row>
      <c-col xs="12" md="6">
        <c-card>
          <c-card-header>
            <strong>Block Level CButtons</strong>
            <small>
              Add this
              <code>block</code>
            </small>
          </c-card-header>
          <c-card-body>
            <c-button size="lg" color="secondary" block>Block level button</c-button>
            <c-button size="lg" color="primary" block>Block level button</c-button>
            <c-button size="lg" color="success" block>Block level button</c-button>
            <c-button size="lg" color="info" block>Block level button</c-button>
            <c-button size="lg" color="warning" block>Block level button</c-button>
            <c-button size="lg" color="danger" block>Block level button</c-button>
            <c-button size="lg" color="link" block>Block level button</c-button>
          </c-card-body>
        </c-card>
      </c-col>
      <c-col xs="12" md="6">
        <c-card>
          <c-card-header>
            <strong>Block Level CButtons</strong>
            <small>
              Add this
              <code>block</code>
            </small>
          </c-card-header>
          <c-card-body>
            <c-button size="lg" variant="outline" color="secondary" block>Block level button</c-button>
            <c-button size="lg" variant="outline" color="primary" block>Block level button</c-button>
            <c-button size="lg" variant="outline" color="success" block>Block level button</c-button>
            <c-button size="lg" variant="outline" color="info" block>Block level button</c-button>
            <c-button size="lg" variant="outline" color="warning" block>Block level button</c-button>
            <c-button size="lg" variant="outline" color="danger" block>Block level button</c-button>
            <c-button size="lg" variant="ghost" color="info" block>Block level button</c-button>
          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
  </div>
</template>

<script>
export default {
  name: 'StandardButtons',
  data() {
    return { togglePress: false };
  },
};
</script>
